import { useState } from 'react';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';
import { textColorByBg } from '../../utils/ui';
import { DewIntensityIcon } from '../GlobalComponents';
import { resizeImageCard } from '../../utils/images';
import { getCropName } from '../../utils/crops';

const MapMarker = ({
  t,
  crop,
  color,
  value,
  imgDay,
  imgNight,
  imgType,
  name,
  description,
  onClickMarker,
  onClickImage,
}) => {
  const [loadImg, setLoadImg] = useState(false);
  const { widthViewport } = useViewport();
  const onMouseOverMarker = () => {
    if (widthViewport > BreakpointMobile) {
      setLoadImg(true);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <div className={styles.mapMarker} onMouseOver={() => onMouseOverMarker()}>
      {/*Image*/}
      <button className={styles.mapMarkerImgContainer} onClick={() => onClickImage()}>
        <figure className={styles.mapMarkerImgWrapper}>
          <div className={styles.mapMarkerImg}>
            {(imgType === 'day' && imgDay) || (imgType === 'night' && imgNight) ? (
              <img
                src={loadImg ? (imgType === 'day' ? resizeImageCard(imgDay) : resizeImageCard(imgNight)) : ''}
                alt=""
                loading="lazy"
              />
            ) : (
              <CroplerIcon name="cropler" />
            )}
          </div>
          {description && (
            <figcaption className={styles.mapMarkerImgCaption}>
              <CroplerIcon name="aiColored" /> {description}
            </figcaption>
          )}
        </figure>
      </button>
      {/*Marker*/}
      <button className={styles.mapMarkerBlock} onClick={() => onClickMarker()}>
        <div className={styles.mapMarkerTitle}>
          <div className={styles.mapMarkerName}>{name || t('empty.noName')}</div>
          {crop && <span className={styles.mapMarkerCrop}>{getCropName({ t, id: crop })}</span>}
        </div>
        <div
          className={styles.mapMarkerData}
          style={{
            background: color,
            color: textColorByBg({ hex: color }),
          }}
        >
          <span>{value.value !== null ? value.value : '-'}</span>
          {value.valueDt === null ? (
            ''
          ) : (
            <span className={`${styles.mapMarkerStatus} ${!value.valueDt ? styles.mapMarkerStatusDown : ''}`}>
              <CroplerIcon name="topCircle" />
            </span>
          )}
          {value.valueDew ? <div className={styles.mapMarkerDew}><DewIntensityIcon seconds={value.valueDew} /></div> : ''}
        </div>
        <div className={styles.mapMarkerArrow}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" fill="none">
            <path fill="#fff" d="m0 0 4.4 5.867a2 2 0 0 0 3.2 0L12 0H0Z" />
          </svg>
        </div>
      </button>
    </div>
  );
};

export default MapMarker;
